export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-6.9eed2be7.png";